import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PublicService } from '../public.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  user = {
    name: 'آنا آوتیسیان',
    cohort: 'Cohort-1',
    telmain: 'مشخص نشده',
    phone: '۰۹۱۲۱۲۳۴۵۶۷',
    address: 'مشخص نشده',
  };

  editMode: boolean = false;
  profileForm: FormGroup;

  constructor(private router: Router, private publicService: PublicService, private alertController: AlertController, private loadingController: LoadingController, private fb: FormBuilder) { }

  ngOnInit() {
    this.user.name = this.publicService.user_basics.name + ' ' + this.publicService.user_basics.famili;
    this.user.cohort = this.publicService.user_basics.codecohort;
    this.user.phone = this.publicService.user_info.person_mobile;
    this.user.telmain = this.publicService.user_info.telmain;
    this.user.address = this.publicService.user_info.address;

    this.profileForm = this.fb.group({
      phone: [this.user.phone, [Validators.required, Validators.pattern(/^\d{10}$/)]],
      telmain: [this.user.telmain, [Validators.required, Validators.pattern(/^\d{8}$/)]],
      address: [this.user.address, Validators.required]
    });
  }

  private async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      cssClass: 'rtl-alert',
      buttons: ['باشه']
    });
    await alert.present();
  }

  async changePassword() {
    const alert = await this.alertController.create({
      header: 'تغییر رمز عبور',
      cssClass: 'rtl-alert',
      inputs: [
        {
          name: 'currentPassword',
          type: 'password',
          placeholder: 'رمز عبور فعلی'
        },
        {
          name: 'newPassword',
          type: 'password',
          placeholder: 'رمز عبور جدید'
        },
        {
          name: 'confirmPassword',
          type: 'password',
          placeholder: 'تکرار رمز عبور جدید'
        }
      ],
      buttons: [
        {
          text: 'لغو',
          role: 'cancel'
        },
        {
          text: 'تغییر',
          handler: async (data) => {
            if (data.newPassword !== data.confirmPassword) {
              this.showAlert('خطا', 'رمز عبور جدید و تکرار آن مطابقت ندارند');
              return false;
            }
            const loading = await this.loadingController.create({
              message: 'در حال تغییر رمز عبور...',
            });
            await loading.present();
            this.publicService.password = data.currentPassword;
            this.publicService.newPass = data.newPassword;
            this.publicService.username = this.publicService.user_basics.codemeli || this.publicService.username;
            try {
              const res = await this.publicService.changePass();
              await loading.dismiss();
              if (res.status == 'success') {
                this.showAlert('موفق', 'رمز عبور تغییر یافت');
              } else {
                this.showAlert('خطا', 'تغییر رمز عبور ناموفق');
              }
            } catch (err) {
              await loading.dismiss();
              this.showAlert('خطا', 'رمز عبور فعلی صحیح نیست');
            }
            return true;
          }
        }
      ]
    });
    await alert.present();
  }

  changeProfile() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.profileForm.patchValue({
        phone: this.user.phone,
        telmain: this.user.telmain,
        address: this.user.address
      });
    } else {
      this.profileForm.reset();
    }
  }

  async saveProfile() {
    if (this.profileForm.valid) {
      const payload = this.profileForm.value;
      const loading = await this.loadingController.create({
        message: 'در حال بروزرسانی پروفایل...',
      });
      await loading.present();
      try {
        const res = await this.publicService.updateProfile(payload);
        await loading.dismiss();
        if (res.status == 'success') {
          // Update local user and service
          this.user.phone = payload.phone;
          this.user.telmain = payload.telmain;
          this.user.address = payload.address;
          this.publicService.user_info.person_mobile = payload.phone;
          this.publicService.user_info.telmain = payload.telmain;
          this.publicService.user_info.address = payload.address;
          localStorage.setItem('user_info', JSON.stringify(this.publicService.user_info));
          this.editMode = false;
          this.showAlert('موفق', 'پروفایل بروزرسانی شد');
        } else {
          this.showAlert('خطا', 'بروزرسانی پروفایل ناموفق');
        }
      } catch (err) {
        await loading.dismiss();
        this.showAlert('خطا', 'خطا در بروزرسانی پروفایل');
      }
    } else {
      this.showAlert('خطا', 'لطفا فیلدها را به درستی پر کنید');
    }
  }

  back() {
    this.router.navigate(['/home']);
  }

}
